<template>
  <v-card flat>
    <v-container grid-list-xs>
      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <barchart
                  v-if="loaded"
                  :chartdata="loanAccountStatsData"
                  :options="loanAccountStatsOptions"
                ></barchart>
                
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>
         <v-flex xs12 sm6 md6>
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                 <piechart
                  v-if="loaded"
                  :chartdata="installStatsData"
                  :options="installStatsOptions"
                ></piechart>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>
        <!-- <v-flex xs12 sm6 md6>
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <linechart
      v-if="loaded"
      :chartdata="revenueChartData"
      :options="revenueChartOptions"
      ></linechart>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex> -->
        <!-- <v-flex xs12 sm6 md6>
          <v-card-text>
            <h2 class="dark-grey--text font-weight-bold">Address Information</h2>
            <v-container grid-list-xs>
              <v-layout wrap></v-layout>
            </v-container>
          </v-card-text>
        </v-flex> -->
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
import Api from "@/services/Api";
import BarChart from "./BarChart.vue";
import PieChart from "./PieChart.vue";
import LineChart from "./LineChart.vue";
import DoughnutChart from "./DoughnutChart.vue";

export default {
  components: {
    barchart: BarChart,
    piechart: PieChart,
    linechart: LineChart,
    doughnutchart: DoughnutChart
  },
  props: [
    "locations",
    "addressinfo",
    "locationnodes",
    "networkfibrefarmers",
    "allfibrefarmers",
    "partners",
    "transactions",
    "completedpassiveinstalls",
    "completedactiveinstalls",
    "totalunits",
    "onceoffdataincome",
    "onceoffdatacosts",
    "recurringdataincome",
    "recurringdatacosts"
  ],
  data() {
    return {
      loaded: false,
      installStatsOptions:'',
      installStatsData:'',
      addFibreFarmerModal: false,
      revenueChartData:[],
      revenueChartOptions:[],
      loanAccounts: [],
      lenders: [],
      loanAmounts: [],
      editFibreFarmerModal: false,
      networkStatus: ["Planned", "In Progress", "Live"],
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Fibre Farmer Type",
          align: "center",
          value: "fibreFarmer.fibreFarmerType"
        },
        {
          text: "Name",
          align: "center",
          value: "fibreFarmer.name"
        },
        {
          text: "Customer",
          align: "center",
          value: "fibreFarmer.customer.name"
        }
      ],
      investmentHeaders: [
        {
          text: "Lender",
          align: "center",
          value: "loanAccountCustomer.name"
        },
        {
          text: "Contribution",
          align: "center",
          value: "amount"
        },
        {
          text: "Investment Per Unit",
          align: "center",
          value: "costPerUnit"
        }
      ],
      editedItem: {
        fibreFarmerId: null,
        locationNetworkId: null,
        fibreFarmerSettingId: null,
        percentageVas: 0,
        percentageBas: 0,
        basExpense: 0,
        equipmentSaleShared: false,
        isActive: true,
        isDeleted: false
      },
      defaultItem: {
        fibreFarmerId: null,
        locationNetworkId: null,
        percentageVas: 0,
        percentageBas: 0,
        basExpense: 0,
        equipmentSaleShared: false,
        isActive: true,
        isDeleted: false
      }
    };
  },
  created() {
    this.getLoanAccounts();
    this.loadChartData();
  },
  methods: {
    mean(numerator, denominator) {
      return numerator / denominator;
    },
    getLoanAccounts() {
      var newArray = this.transactions.filter(function(el) {
        return el.transactionType === "Loan";
      });
      this.loanAccounts = [];
      var res = {};

      newArray.forEach(function(el) {
        res[el.loanAccountCustomer.name] = res[el.loanAccountCustomer.name]
          ? (res[el.loanAccountCustomer.name] += +el.amount)
          : +el.amount;
      });

      this.loanAccounts.push(
        Object.keys(res).map(function(el) {
          return { loanAccountCustomerName: el, amount: res[el] };
        })
      );
      this.loanAccounts = this.loanAccounts[0];
      this.lenders = [];
      this.loanAmounts = [];
      for (let i = 0; i < this.loanAccounts.length; i++) {
        this.lenders.push(this.loanAccounts[i].loanAccountCustomerName);
        this.loanAmounts.push(this.loanAccounts[i].amount);
      }
    },
    edit(item) {
      this.editedItem = Object.assign({}, item);
      (this.editedItem.percentageVas = item.fibreFarmerSetting.percentageVas),
        (this.editedItem.percentageBas = item.fibreFarmerSetting.percentageBas),
        (this.editedItem.basExpense = item.fibreFarmerSetting.basExpense),
        (this.editedItem.equipmentSaleShared =
          item.fibreFarmerSetting.equipmentSaleShared),
        (this.editedItem.fibreFarmerSettingId = item.fibreFarmerSetting.id),
        (this.editFibreFarmerModal = true);
    },
    editFibreFarmerSettings() {
      Api()
        .put("/fibrefarmersettings/" + this.editedItem.fibreFarmerSettingId, {
          percentageVas: this.editedItem.percentageVas,
          percentageBas: this.editedItem.percentageBas,
          basExpense: this.editedItem.basExpense,
          equipmentSaleShared: this.editedItem.equipmentSaleShared,
          isActive: this.editedItem.isActive,
          isDeleted: this.editedItem.isDeleted
        })
        .then(this.$emit("fibreFarmerSettingsUpdated"));
      this.close();
    },
    close(item) {
      this.addFibreFarmerModal = false;
      this.editFibreFarmerModal = false;
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    addFibreFarmer() {
      Api()
        .post("/fibrefarmersettings", {
          percentageVas: this.editedItem.percentageVas,
          percentageBas: this.editedItem.percentageBas,
          basExpense: this.editedItem.basExpense,
          equipmentSaleShared: this.editedItem.equipmentSaleShared,
          isActive: this.editedItem.isActive,
          isDeleted: this.editedItem.isDeleted
        })
        .then(response => {
          Api()
            .post("/fibrefarmerlocationnetwork", {
              locationNetworkId: this.$route.params.locationNetworkId,
              fibreFarmerId: this.editedItem.fibreFarmerId,
              fibreFarmerSettingId: response.data.id,
              isActive: true,
              isDeleted: false
            })
        });
    },
    save() {
      Api().put("/locationnetworks/" + this.$route.params.locationNetworkId, {
        name: this.addressinfo.name,
        locationNodeId: this.addressinfo.locationNodeId,
        lineRentalIncluded: this.addressinfo.lineRentalIncluded,
        residentialLineRentalValue: this.addressinfo.residentialLineRentalValue,
        tvOverFibre: this.addressinfo.tvOverFibre,
        gtuIncluded: this.addressinfo.gtuIncluded,
        gtuFee: this.addressinfo.gtuFee,
        activationFee: this.addressinfo.activationFee,
        activationFeeAmount: this.addressinfo.activationFeeAmount,
        routerInstallationFee: this.addressinfo.routerInstallationFee,
        routerInstallationFeeAmount: this.addressinfo
          .routerInstallationFeeAmount,
        networkStatus: this.addressinfo.networkStatus,
        streetNumber: this.addressinfo.streetNumber,
        streetName: this.addressinfo.streetName,
        suburb: this.addressinfo.suburb,
        town: this.addressinfo.town,
        city: this.addressinfo.city,
        country: this.addressinfo.country,
        geoLongitude: this.addressinfo.geoLongitude,
        geoLatitude: this.addressinfo.geoLatitude,
        geoHightAboveGroundLevel: this.addressinfo.geoHightAboveGroundLevel
      });
    },
    subtract(number1, number2){
      return number1-number1
    },
    loadChartData() {
      try {
        (this.loanAccountChartOptions = {
          title: {
            display: true,
            text: "Loan Accounts By Lender"
          },
          tooltip: {
            enabled: true
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        }),
          (this.loanAccountStatsData = {
            labels: this.lenders,
            datasets: [
              {
                label: "Loan Account Balances",
                data: this.loanAmounts,
                backgroundColor: [
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(54, 162, 235, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)"
                ],
                borderColor: [
                  "rgba(255, 99, 132, 1)",
                  "rgba(54, 162, 235, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)"
                ],
                borderWidth: 1
              }
            ]
          }),
          (this.loanAccountStatsOptions = {
            title: {
              display: true,
              text: "Loan Account Balances"
            },
            tooltip: {
              enabled: true
            },
            legend: {display: false},
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
            }
          }),

          (this.installStatsData = {
            labels: ['Units Passed','Units Connected','Units Live'],
            datasets: [
              {
                label: "Loan Account Balances",
                data: [this.totalunits,this.completedpassiveinstalls, this.completedactiveinstalls],
                backgroundColor: [
                  'rgba(0,255,0, 0.2)',
                  "rgba(54, 162, 235, 0.2)",
                  'rgba(153, 102, 255, 0.2)',
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 99, 132, 0.2)"
                ],
                borderColor: [
                  'rgba(0,255,0, 1)',
                  "rgba(54, 162, 235, 1)",
                  'rgba(153, 102, 255, 1)',
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)",
                  "rgba(255, 99, 132, 1)"
                ],
                borderWidth: 1
              }
            ]
          }),
          (this.installStatsOptions = {
            title: {
              display: true,
              text: "Installation Statistics"
            },
            tooltip: {
              enabled: true
            },
            legend: {display: false},
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
            }
          }),
          this.revenueChartData = {
        labels: this.labels,
        datasets: [{
            label: 'Once Off Income',
            data: this.onceoffdataincome,
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)'
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)'
            ],
            borderWidth: 1
        },
        {
            label: 'Once Off Costs',
            data: this.onceoffdatacosts,
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)'
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)'
            ],
            borderWidth: 1
        },
        {
            label: 'Recurring Income',
            data: this.recurringdataincome,
            backgroundColor: [
                'rgba(54, 162, 235, 0.2)'
            ],
            borderColor: [
                'rgba(54, 162, 235, 1)'
            ],
            borderWidth: 1
        },
        {
            label: 'Recurring Costs',
            data: this.recurringdatacosts,
            backgroundColor: [
                'rgba(54, 162, 235, 0.2)'
            ],
            borderColor: [
                'rgba(54, 162, 235, 1)'
            ],
            borderWidth: 1
        }]
    },
    this.revenueChartOptions={
        title: {
            display: true,
            text: 'Monthly Revenue'
        },
        tooltip: {
            enabled: true
        },
        scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            callback: function(value, index, values) {
              if(parseInt(value) >= 1000){
                return 'R' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return 'R' + value;
              }
            }
          }
        }]
      }
    },
          (this.loaded = true);
      } catch {}
    }
  }
};
</script>

